import React from 'react';
import './css/VisionMission.css';

const VisionMission: React.FC = () => {
    return (
        <div className="vision-mission-page">
            <div className="vision-hero-section">
                <div className="vision-hero-content">
                    <h1 className="vision-main-title">Эрхэм зорилго ба Алсын хараа</h1>
                    <p className="vision-hero-subtitle">
                        Бидний зорилго — хүмүүсийн амьдралыг хялбарчилж, орон нутгийн хөгжилд урам зориг шингээх явдал юм.
                    </p>
                </div>
            </div>

            <div className="vision-content-section">
                <div className="vision-container">
                    <div className="vision-top-grid">
                        <div className="vision-card vision-purpose">
                            <div className="vision-icon">🌿</div>
                            <h2 className="vision-title">Эрхэм зорилго</h2>
                            <div className="vision-text">
                                <p>
                                    Бид Эрдэнэт, Булган, Хөвсгөлийн иргэддээ өөрийн нутагтаа, итгэлтэйгээр,
                                    цаг хэмнэж автомашинтай холбоотой бүх хэрэгцээгээ нэг дор шийдэх боломжийг бүрдүүлнэ.
                                </p>
                                <p>
                                    Бидний зорилго — хүмүүсийн амьдралыг хялбарчилж, орон нутгийн хөгжилд урам зориг шингээх явдал юм.
                                </p>
                            </div>
                        </div>

                        <div className="vision-card vision-vision">
                            <div className="vision-icon">🌄</div>
                            <h2 className="vision-title">Алсын хараа</h2>
                            <div className="vision-text">
                                <p>
                                    Хойд бүсийн авто худалдаа, үйлчилгээний хамгийн итгэл даах цогц төв болж,
                                    иргэдийн итгэл, орон нутгийн бахархал дээр тулгуурласан шинэ амьдралын хэв маягийг бүтээх.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="vision-values-section">
                        <div className="vision-card vision-values">
                            <div className="values-header">
                                <div className="vision-icon">💎</div>
                                <h2 className="vision-title">Үнэт зүйлс</h2>
                            </div>
                            <div className="values-grid">
                                <div className="value-item">
                                    <div className="value-icon">❤️</div>
                                    <div className="value-content">
                                        <h3 className="value-title">Хүмүүнлэг сэтгэл</h3>
                                        <p className="value-description">Хүн бүрийн хэрэгцээ, итгэл, сэтгэлд хүндэтгэлтэй хандана.</p>
                                    </div>
                                </div>

                                <div className="value-item">
                                    <div className="value-icon">🛡️</div>
                                    <div className="value-content">
                                        <h3 className="value-title">Найдвартай байдал</h3>
                                        <p className="value-description">Ил тод, шударга, итгэл даах үйлчилгээ үзүүлнэ.</p>
                                    </div>
                                </div>

                                <div className="value-item">
                                    <div className="value-icon">🤝</div>
                                    <div className="value-content">
                                        <h3 className="value-title">Нэгдэл ба хөгжил</h3>
                                        <p className="value-description">Орон нутгийн бизнес, иргэдтэйгээ хамтран өсөж, хамтын үнэ цэнийг бүтээнэ.</p>
                                    </div>
                                </div>

                                <div className="value-item">
                                    <div className="value-icon">🌱</div>
                                    <div className="value-content">
                                        <h3 className="value-title">Хариуцлага</h3>
                                        <p className="value-description">Байгаль орчин, нийгэм, эдийн засгийн өмнө ухамсартайгаар хандана.</p>
                                    </div>
                                </div>

                                <div className="value-item">
                                    <div className="value-icon">💡</div>
                                    <div className="value-content">
                                        <h3 className="value-title">Шинийг санаачлагч байдал</h3>
                                        <p className="value-description">Орчин үеийн шийдэл, дэвшилтэт технологиор авто худалдааны шинэ соёлыг төлөвшүүлнэ.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* <div className="vision-commitment-section">
                <div className="vision-container">
                    <h2 className="commitment-title">Бидний амлалт</h2>
                    <div className="commitment-content">
                        <p>
                            Бид Монголын хойд бүсийн иргэд, бизнесүүдийн хэрэгцээг ойлгож, тэдний амьдралыг хялбарчлах,
                            хөгжүүлэхэд хувь нэмрээ оруулахад үргэлж зоригжсон байх болно.
                            Манай багийн гишүүн бүр эдгээр үнэт зүйлсийг өдөр тутмын үйл ажиллагаандаа амьдаар тусгаж,
                            хэрэглэгч, түнш, нийгмийнхээ итгэлийг хүлээхэд бэлэн байна.
                        </p>
                    </div>
                </div>
            </div> */}
        </div>
    );
};

export default VisionMission;